import prizemlje2i1 from '../assets/img/aprtmani_novo/Prizemlje2-1.jpg';
import prizemlje2i2 from '../assets/img/aprtmani_novo/Prizemlje2-2.jpg';
import prizemlje2i3 from '../assets/img/aprtmani_novo/Prizemlje2-3.jpg';
import prizemlje2i4 from '../assets/img/aprtmani_novo/Prizemlje2-4.jpg';

const prizemlje2 = [
{
    id: 1,
    title: 'Prizemlje 2-1',
    text: 'Poseduje jasno definisane dnevne i noćne zone. Njihove pozije u zgradi su na nivoima prizemlja i prizemlja 2 kao i potrkovlja 1. Svaki od njih poseduje terasu.',
    size: '20.7',
    image: prizemlje2i1
},
{
    id: 2,
    title: 'Prizemlje 2-2',
    text: 'Prostire se na dve poslednje etaže, definisan tako da je dnevni boravak sa kuhinjom, kupatilom i ulaznim delom smešten na prvi nivo dok je noćna zona spavanje na drugom nivou do koga vodi stepenište.',
    size: '20.7',
    image: prizemlje2i2
},
{
    id: 3,
    title: 'Prizemlje 2-3',
    text: 'Prostire se na dve poslednje etaže, definisan tako da je dnevni boravak sa kuhinjom, kupatilom i ulaznim delom smešten na prvi nivo dok je noćna zona spavanje na drugom nivou u vidu galerije otvorenog prostora do koga vodi stepenište.',
    size: '31.4',
    image: prizemlje2i3
},
{
    id: 4,
    title: 'Prizemlje 2-4',
    text: 'Prostire se na dve poslednje etaže, definisan tako da je dnevni boravak sa kuhinjom, kupatilom i ulaznim delom smešten na prvi nivo dok je noćna zona spavanje na drugom nivou u vidu galerije otvorenog prostora do koga vodi stepenište.',
    size: '31.4',
    image: prizemlje2i4
}

]

export default prizemlje2;